export const productDataAccesorios = [
    {
      id: "1Sombrerocapelina",
      imageurl:
      'https://http2.mlstatic.com/D_NQ_NP_931743-MLA53070744837_122022-W.webp',
      name: "Sombrero capelina",
      price: "1700",
      description: "accesorios",
      IsSale: "Sale",
      signo: "$",
      pricebefore: "2000",
      colorbc: "pink",
      color: "blue-dark",
      IsTalla: "Talla",
      tallas: [1,2],
      quantity: 1,
    },
    {
      id: "2Sombreroplayero",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_745482-MLA48632045940_122021-W.webp",
      name: "Sombrero playero",
      price: "3000",
      description: "accesorios",
      color: "brown",      
      IsSale: "Nuevo",
      colorbc: "pink",
      IsTalla: "Talla",
      tallas: [1,2],
      quantity: 1,
    },
    {
      id: "3Pareoplayero",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_688780-MLA51824963867_102022-W.webp",
      name: "Pareo playero",
      price: "2200",
      description: "accesorios",
      color: "red",      
      IsTalla: "Talla",
      tallas: [ 1,2,3, 4 , 5],
      quantity: 1,
    },
    {
      id: "4Camisonkimonoplayero",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_980263-MLA53651245084_022023-W.webp",
      name: "Camison kimono playero",
      price: "2500",
      description: "accesorios",
      color: "pink",       
      IsTalla: "Talla",
      tallas: [ 1,2,3,4,5 ],
      quantity: 1,
    },
    
    {
      id: "5Pareoplayerocrochet",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_781850-MLA53351742011_012023-W.webp",
      name: "Pareo playero crochet",
      price: "4500",
      description: "accesorios",
      color: "white",   
      IsTalla: "Talla",   
      tallas: [ 1,2,3],
      quantity: 1,
    },
    {
      id: "6Remeradetulconmariposas",
      imageurl:
      'https://http2.mlstatic.com/D_NQ_NP_798302-MLA52432745739_112022-W.webp',
      name: "Remera de tul con mariposas",
      price: "8000",
      description: "accesorios",
      color: "jean",
      tallas: [ 1,2,3,4],
      IsTalla: "Talla",
      quantity: 1,
    },
    {
      id: "7Pañuelodeseda",
      imageurl:
      'https://http2.mlstatic.com/D_NQ_NP_898539-MLA51556709175_092022-O.webp',
      name: "Pañuelo de seda",
      price: "1200",
      description: "accesorios",
      color: "black",
      tallas: [ 1,2,3],
      IsTalla: "Talla",
      quantity: 1,
    },
    {
      id: "8CinturondeStrass",
      imageurl:
      'https://http2.mlstatic.com/D_NQ_NP_617440-MLA48446917042_122021-O.webp',
      name: "Cinturon de Strass",
      price: "4000",
      description: "accesorios",
      color: "white",
      tallas: [ 1,2,3,4,5],
      IsTalla: "Talla",
      quantity: 1,
    },
  ];